<h2 mat-dialog-title>Edit user</h2>
<mat-dialog-content>
  <form [formGroup]="userForm" class="mt-2" (ngSubmit)="updateUser()">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Display Name</mat-label>
      <input matInput formControlName="displayName" type="text" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        @for (role of roles; track role) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="d-flex justify-content-between">
      <button mat-dialog-close mat-raised-button [disabled]="loading">Cancel</button>

      <button mat-raised-button color="primary" type="submit" [disabled]="loading || userForm.invalid">
        {{ loading ? 'Updating...' : 'Update User' }}
      </button>
    </div>
  </form>
</mat-dialog-content>
